import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
// import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { BasicChartComponent } from '../animation-base-classes/basic-chart.component';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import * as d3 from 'd3';

@Component({
  selector: 'app-demo-dst-triptych-line-hor-steps',
  templateUrl: './demo-dst-triptych-line-hor-steps.component.html',
  styleUrls: ['./demo-dst-triptych-line-hor-steps.component.scss']
})
export class DemoDSTTriptychLineHorStepsComponent extends BasicChartComponent {

  private backgroundGroup;
  private slide01Group;
  private slide02Group;
  private slide03Group;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createLineScales(this.data, this.values);
    this.values['colorScheme'] = { 'value': { 1: this.values['titleTextSlide1FontColor'] } }
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01Group.selectAll('*').remove();
    this.drawBackgroundSlide1(this.slide01Group, this.values);
    this.drawArrow(this.slide01Group, this.values);
    let logoGroup = this.drawLogoBackground(this.slide01Group, this.values, false);
    this.drawDSTCrownLogo(logoGroup, 'slide1');
    // this.drawTilastokeskusLogo(logoGroup, this.values, 'slide1');
    this.drawTitleTextSlide1(this.slide01Group, this.values);
    this.drawTextSlide1(this.slide01Group, this.values);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02Group.selectAll('*').remove();
    this.drawBackgroundSlide2(this.slide02Group, this.values);
    this.drawTitleSlide2(this.slide02Group, this.values);
    this.drawSubTitleSlide2(this.slide02Group, this.values);
    this.drawLogoBackground(this.slide02Group, this.values, false);
    this.drawDSTCrownLogo(this.slide02Group, 'slide2');
    this.drawBarsHorSteps(this.slide02Group, this.values, this.data);

    this.slide03Group = this.host.select('#slide-03-text');
    this.slide03Group.selectAll('*').remove();
    // this.drawBackgroundSlide3(this.slide03Group, this.values);
    // this.drawDSTCrownLogo(this.slide03Group, 'slide3', 200, 200, 200);
    // this.drawTilastokeskusLogo(this.slide03Group, this.values, null, 460, 220, 60, null); // NB these need to be moved to params!
    // this.drawTilastokeskusText(this.slide03Group, this.values);
    // this.drawTilastokeskusWWW(this.slide03Group, this.values);
    this.drawDSTWWW(this.slide03Group, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {
      // Slide 01
      let slide01AnimationTotal = new TimelineMax();
      let slide01AppearAnimation = new TimelineMax();
      this.animateSlide1(slide01AppearAnimation);
      slide01AppearAnimation.duration(this.timings['slide1Animation']);
      slide01AnimationTotal.add(slide01AppearAnimation);
      let pauseSlide01 = new TimelineMax()
        .set({}, {}, this.timings['pauseSlides']);
      slide01AnimationTotal.add(pauseSlide01);
      let slide01SlideOutAnimation = new TimelineMax();
      slide01SlideOutAnimation.to(this.slide01Group.node(), 1, { x: -this.values['width'] });
      slide01AnimationTotal.add(slide01SlideOutAnimation);
      main.add(slide01AnimationTotal);
      // Slide 02
      let slide02AnimationTotal = new TimelineMax();
      let linesAnimation = new TimelineMax();
      this.animateBarsSlide2(linesAnimation, this.values, this.data);
      linesAnimation.duration(this.timings['slide2Animation']);
      slide02AnimationTotal.add(linesAnimation);
      let pauseSlide02 = new TimelineMax()
        .set({}, {}, this.timings['pauseSlides']);
      slide02AnimationTotal.add(pauseSlide02);
      let slide02SlideOutAnimation = new TimelineMax();
      slide02SlideOutAnimation.to(this.slide02Group.node(), 1, { x: -this.values['width'] });
      slide02AnimationTotal.add(slide02SlideOutAnimation);
      main.add(slide02AnimationTotal);
      // Slide 03
      let slide03AnimationTotal = new TimelineMax();
      let logoAnimation = new TimelineMax();
      this.animateDanmarksStatistik(logoAnimation);
      logoAnimation.duration(this.timings['slide3Animation']);
      slide03AnimationTotal.add(logoAnimation);
      let pauseSlide03 = new TimelineMax()
        .set({}, {}, this.timings['pauseEnd']);
      slide03AnimationTotal.add(pauseSlide03);
      // let slide03SlideOutAnimation = new TimelineMax();
      // slide03SlideOutAnimation.to(this.slide03Group.node(), 1, { x: -this.values['width'] });
      // slide03AnimationTotal.add(slide03SlideOutAnimation);
      main.add(slide03AnimationTotal);
    }

    this.animation = main;
    return this.animation;
  }

  public drawBackgroundSlide1(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['backgroundColor'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide2(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      // .attr('fill', '#CACACA')
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['bannerHeight'])
      .attr('fill', values['backgroundColor'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide3(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      // .attr('fill', '#CACACA')
      .attr('stroke', 'none');
  }

  public drawArrow(selection, values) {
    let group = selection.append('g')
      .attr('transform', `translate(${values['iconX']} ${values['iconY']})`)
      .attr('id', `slide1-icon-${this.id}`);
    group.append('path')
      .attr('fill', values['iconColor'])
      .attr('stroke', values['iconBorderColor'])
      .attr('stroke-width', values['iconBorderWidth'])
      .attr('opacity', values['iconOpacity'])
      .attr('d', 'M268.467778,119.653796 L153.560389,6.43501062 C149.20681,2.14480049 143.858499,0 137.500618,0 C131.029601,0 125.731985,2.14480049 121.613952,6.43501062 L6.70656313,119.653796 C2.23490281,124.059135 0,129.336769 0,135.481827 C0,141.510537 2.23737573,146.726039 6.70656313,151.132596 L19.9434937,164.173787 C24.1808447,168.578517 29.4766061,170.786059 35.8301597,170.786059 C42.1843315,170.786059 47.4788565,168.578517 51.7168257,164.173787 L103.610465,113.218176 L103.610465,235.655157 C103.610465,241.679604 105.815693,246.580787 110.22924,250.351396 C114.642786,254.11835 119.967605,256 126.202458,256 L148.795687,256 C155.033013,256 160.355359,254.117741 164.768905,250.351396 C169.182452,246.582005 171.391389,241.679604 171.391389,235.655157 L171.391389,113.218785 L223.284411,164.174396 C227.518052,168.579126 232.813195,170.786668 239.172931,170.786668 C245.40593,170.786668 250.762896,168.579126 255.231465,164.174396 L268.467159,151.133205 C272.821356,146.609693 275,141.394191 275,135.482436 C275.000618,129.453116 272.821974,124.177309 268.467778,119.653796 Z');
  }

  public drawLogoBackground(selection, values, border?: boolean) {
    let group = selection.append('g')
      .attr('id', `slide1-logo-group-${this.id}`);
    group.append('circle')
      .attr('cx', values['logoBackgroundX'])
      .attr('cy', values['logoBackgroundY'])
      .attr('r', values['logoBackgroundRadius'])
      .attr('fill', values['logoBackgroundColor'])
      .attr('stroke', border ? values['logoBorderColor'] : 'none')
      .attr('stroke-width', border ? values['logoBackgroundRadiusWidth'] : null);
    return group;
  }

  public drawDSTCrownLogo(selection, id?: string, x?: number, y?: number, w?: number, h?: number) {
    let g = (k): any => this.values[k];
    let s = (k, v): void => this.values[k] = v;
    const logoWidth = 59;
    const logoHeight = 55;
    let factor, actualLogoHeight;
    if (w || g('logoWidth')) {
      factor = (w || g('logoWidth')) / logoWidth;
      actualLogoHeight = logoHeight * factor;
    } else if (h || g('logoHeight')) {
      factor = (h || g('logoHeight')) / logoHeight;
      s('logoWidth', logoWidth * factor)
      w = logoWidth * factor;
      actualLogoHeight = h || g('logoHeight');
    } else {
      factor = 1;
      actualLogoHeight = logoHeight;
    }
    let blue = '#0079CB';
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // console.log(idValue);
    let outerGroup = selection.append('g')
      .attr('id', `dst-logo-outer-group${idValue}`)
      .attr('transform', `translate(${x || g('logoX') - (w || g('logoWidth')) / 2} ${(y || g('logoY')) - actualLogoHeight / 2})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `dst-logo-inner-group-${idValue}`)
      .attr('transform', `scale(${factor} ${factor})`);
    let top = innerGroup.append('path')
      .attr('id', `dst-logo-top-${idValue}`)
      .attr('class', `dst-logo-top-${idValue} dst-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M55.1,17.7 C52.8,16.5 50.6,16.7 48.4,17.6 C47.5,16.5 46.1,15.7 44.7,15.4 C39.5,14.4 35.8,19.7 31.5,19.7 C31.3,18.8 31.1,18 30.8,17.6 C32.8,17.1 34.1,15.3 34.1,13.2 C34.1,10.9 32.5,9.1 30.3,8.8 L30.3,6.4 L32.2,6.4 C32.5,6.9 33,7.3 33.6,7.3 C34.5,7.3 35.1,6.6 35.1,5.8 C35.1,4.9 34.4,4.3 33.6,4.3 C33,4.3 32.5,4.7 32.2,5.2 L30.3,5.2 L30.3,3.2 C30.8,2.9 31.1,2.4 31.1,1.8 C31.1,0.9 30.4,0.3 29.6,0.3 C28.7,0.3 28.1,1 28.1,1.8 C28.1,2.4 28.4,2.9 28.9,3.2 L28.9,5.1 L27.1,5.1 C26.8,4.6 26.3,4.2 25.7,4.2 C24.8,4.2 24.2,4.9 24.2,5.7 C24.2,6.6 24.9,7.2 25.7,7.2 C26.3,7.2 26.8,6.8 27.1,6.4 L29,6.4 L29,8.8 C26.9,9.2 25.2,11 25.2,13.2 C25.2,15.3 26.7,17.1 28.5,17.6 C28.3,18 28.1,18.8 27.8,19.7 C23.6,19.7 19.9,14.4 14.6,15.4 C13.1,15.7 11.8,16.4 10.9,17.6 C8.7,16.7 6.5,16.6 4.2,17.7 C-1,20.5 -0.4,26.4 3.7,31.6 C7,35.8 7.6,39.2 7.8,41.3 L7.8,43.2 C7.9,43.8 8.1,43.9 8.5,43.9 L51,43.9 C51.4,43.9 51.7,43.8 51.7,43.2 L51.7,41.3 C51.8,39.2 52.4,35.8 55.8,31.6 C59.6,26.4 60.2,20.5 55.1,17.7 Z M16.7,38.3 C14.5,38.8 12.6,39.5 11.5,40 C11.3,40.1 11.2,39.9 11.4,39.6 C12.1,38.5 13.1,35.2 11.9,32.8 C11.1,33.1 9.9,33.7 9.9,33.7 C9,30.7 1.5,25.3 5.9,20.7 C6.9,19.7 8.3,19.5 9.9,19.8 C9.1,22.2 9.5,25.3 11.9,28.5 C13.9,31.1 16.8,34.4 17.1,37.9 C16.9,38 16.9,38.2 16.7,38.3 Z M27.6,36.9 C25.3,37 22.9,37.2 21.3,37.4 C21.1,37.4 20.7,37.3 20.9,37 C21.8,35.8 22.7,32.1 22,30.2 C20.5,30.4 18.3,30.9 18.3,30.9 C17.2,27.8 10.7,23.3 14.2,19.4 C17.5,15.9 21.6,22.1 27.4,22.4 C27,24.7 26.7,27.2 26.7,29.8 C26.7,29.8 25.5,29.9 25,29.9 C25,32.1 26,35.1 27.7,36.5 C28,36.7 27.8,36.9 27.6,36.9 Z M38.5,37 C38.8,37.4 38.4,37.5 38.1,37.4 C36.6,37.2 34.1,37 31.8,36.9 C31.6,36.9 31.4,36.7 31.7,36.4 C33.4,35 34.3,32 34.4,29.8 C33.9,29.7 32.7,29.7 32.7,29.7 C32.8,27.1 32.4,24.6 32,22.3 C37.8,22.1 41.8,15.8 45.2,19.3 C48.8,23.2 42.2,27.7 41.1,30.8 C41.1,30.8 38.9,30.3 37.4,30.1 C36.7,32.1 37.5,35.8 38.5,37 Z M49.6,33.8 C49.6,33.8 48.4,33.2 47.6,32.9 C46.4,35.3 47.5,38.6 48.1,39.7 C48.2,39.9 48.1,40.2 48,40.1 C46.9,39.7 45,38.9 42.8,38.4 C42.6,38.3 42.5,38.1 42.5,38 C42.8,34.5 45.8,31.3 47.7,28.6 C50,25.4 50.5,22.3 49.7,19.9 C51.3,19.5 52.8,19.8 53.7,20.8 C58,25.3 50.5,30.7 49.6,33.8 Z');
    let bottom = innerGroup.append('path')
      .attr('id', `dst-logo-bottom-${idValue}`)
      .attr('class', `dst-logo-bottom-${idValue} dst-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M51.6,53.7 C51.6,54 51.4,54.3 51,54.3 L8.5,54.3 C8.2,54.3 7.9,54.1 7.9,53.7 L7.9,48.4 C7.9,48.1 8.1,47.8 8.5,47.8 L51,47.8 C51.3,47.8 51.6,48 51.6,48.4 L51.6,53.7 Z');
  }

  public drawDSTWWW(selection, values) {
    let group = selection.append('g')
      .attr('id', `slide-03-text-${this.id}`);
    let line1 = group.append('text')
      .attr('x', 300)
      .attr('y', 400)
      .attr('fill', '#828282')
      .attr('font-size', 32)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'lighter')
      .attr('font-family', values['fontFamily'])
      .text('www.dst.dk');
    let line2 = group.append('text')
      .attr('x', 300)
      .attr('y', 440)
      .attr('fill', '#828282')
      .attr('font-size', 32)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'lighter')
      .attr('font-family', values['fontFamily'])
      .text('@dstdk');
  }

  public drawTitleTextSlide1(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['titleTextSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['titleTextSlide1FontSize'] * values['titleTextSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['titleTextSlide1Y'];
    let group = selection.append('g')
      .attr('id', `slide1-title-text-${this.id}`);
    let text = group.append('text')
      .attr('x', values['titleTextSlide1X'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['titleTextSlide1FontColor'])
      .attr('font-size', values['titleTextSlide1FontSize'])
      .attr('font-weight', values['titleTextSlide1FontWeight'])
      .attr('font-family', values['fontFamily'])
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['titleTextSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group
  }

  public drawTextSlide1(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['textSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textSlide1FontSize'] * values['textSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['textSlide1Y'];
    let group = selection.append('g')
      .attr('id', `slide1-text-${this.id}`);
    let text = group.append('text')
      .attr('x', values['textX'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['textSlide1FontColor'])
      .attr('font-size', values['textSlide1FontSize'])
      .attr('font-weight', values['textSlide1FontWeight'])
      .attr('font-family', values['fontFamily'])
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['textSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group;
  }

  public drawTitleSlide2(selection, values) {
    let text = selection.append('text')
      .attr('x', values['titleTextSlide2X'])
      .attr('y', values['titleTextSlide2Y'])
      .attr('fill', values['titleTextSlide2FontColor'])
      .attr('font-size', values['titleTextSlide2FontSize'])
      .attr('font-weight', values['titleTextSlide2FontWeight'])
      .attr('font-family', values['fontFamily'])
      .text(values['titleTextSlide2']);
  }

  public drawSubTitleSlide2(selection, values) {
    let line1 = selection.append('text')
      .attr('x', values['subtitleTextSlide2X'])
      .attr('y', values['subtitleTextSlide2Line1Y'])
      .attr('fill', values['subtitleTextSlide2FontColor'])
      .attr('font-size', values['subtitleTextSlide2FontSize'])
      .attr('font-weight', values['subtitleTextSlide2FontWeight'])
      .attr('font-family', values['fontFamily'])
      .text(values['subtitleTextSlide2Line1']);
    let line2 = selection.append('text')
      .attr('x', values['subtitleTextSlide2X'])
      .attr('y', values['subtitleTextSlide2Line2Y'])
      .attr('fill', values['subtitleTextSlide2FontColor'])
      .attr('font-size', values['subtitleTextSlide2FontSize'])
      .attr('font-weight', values['subtitleTextSlide2FontWeight'])
      .attr('font-family', values['fontFamily'])
      .text(values['subtitleTextSlide2Line2']);
  }

  public drawLineHorSteps(selection, values, data) {
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values);
    this.drawNLines(selection, values, data);
  }

  public drawBarsHorSteps(selection, values, data) {
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawBarsAndStuff(selection, values, data);
    this.drawLegend(selection);
  }

  public drawBarsAndStuff(selection, values, data) {
    let g = (k): any => values[k];
    // console.log(data);
    let labels = _.map(_.drop(this.data, this.params['data']['columnLabelNumber']), list => list[0]);
    // console.log(labels);
    let stepSize = g('chartDomainWidth') / labels.length;
    let valueList = _.map(_.drop(this.data, this.params['data']['columnLabelNumber']), list => _.drop(list, this.params['data']['rowLabelNumber']));
    // console.log(valueList);
    let colors = ['#2394d1', '#7ab8e2', '#228441', '#7aa874', '#908d7f'];

    let barWidth = 30;

    _.map(labels, (label, i) => {
      let x = (i + 0.5) * stepSize;
      selection.append('text')
        .attr('x', g('chartDomainX') + x)
        .attr('y', g('chartDomainY') + g('chartDomainHeight') + 30)
        .attr('text-anchor', 'middle')
        .attr('font-family', g('xAxisLabelFontFamily') || values['fontFamily'])
        .attr('font-size', g('xAxisLabelFontSize'))
        .attr('fill', g('fontColor') || g('labelColor'))
        .text(label);
      let list = valueList[i];
      let yValue = 0;
      _.map(list, (value, ii) => {
        let group = selection.append('g')
          .attr('transform', 'scale(1,-1)');
        let startY = -1 * this.scaleY(yValue);
        let endY = -1 * this.scaleY(yValue + value);
        let h = endY - startY;

        group.append('rect')
          .attr('id', `bars-${this.id}-cat${i}-subcat${ii}`)
          .attr('class', `bars-${this.id}-cat${i} bars-${this.id}-subcat${ii}`)
          .attr('x', g('chartDomainX') + x - barWidth / 2)
          .attr('y', startY)
          .attr('width', barWidth)
          .attr('height', h)
          .attr('fill', colors[ii]);
        yValue = yValue + value;
      });
    });
  }

  public drawLegend(selection) {
    let g = (k): any => this.values[k];
    let colors = ['#2394d1', '#7ab8e2', '#228441', '#7aa874', '#908d7f'];

    let legendLabels = _.drop(this.data[0], this.params['data']['rowLabelNumber'] || 0);

    let lS_X = g('chartDomainX');
    let lS_Y = g('chartDomainY') + g('chartDomainHeight') + 30;
    let lS_W = g('chartDomainWidth');
    let legendRows = _.ceil(legendLabels.length / g('legendColumns'));

    let drawLegendItem = (row, column, index) => {
      if (index <= legendLabels.length - 1) {
        let y = lS_Y + g('legendMarginTop') + row * g('legendRowHeight') + row * g('legendVerticalSpacing');
        let w = (lS_W - (g('legendColumns') - 1) * g('legendHorizontalSpacing')) / g('legendColumns');
        let mw = g('legendMarkerWidth');
        let mm = g('legendMarkerMargin');
        let tw = w - mw - mm;
        let x = lS_X + column * w + column * g('legendHorizontalSpacing');
        let label = legendLabels[index];
        let group = selection.append('g')
          .attr('id', `legend-${this.id}-row-${row}-column-${column}`)
          .attr('class', `legend-${this.id}-cat-${index}`);
        group.append('rect')
          .attr('x', x)
          .attr('y', y + g('legendRowHeight') - (g('legendMarkerHeight') || g('legendRowHeight')))
          .attr('width', mw)
          .attr('height', g('legendMarkerHeight') || g('legendRowHeight'))
          .attr('fill', colors[i]);
        group.append('text')
          .attr('x', x + mw + mm)
          .attr('y', y + g('legendRowHeight'))
          .attr('text-anchor', 'start')
          .attr('font-family', g('legendFontFamily'))
          .attr('font-size', g('legendFontSize'))
          .attr('fill', g('labelColor'))
          .text(label);
      }
    }

    let i = 0;
    _.map(_.range(legendRows), row => {
      _.map(_.range(g('legendColumns')), column => {
        drawLegendItem(row, column, i);
        i++;
      });
    });
  }


  public animateSlide1(timeline, values?) {
    timeline.from(`#slide1-logo-group-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#slide1-title-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#slide1-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');

    timeline.from(`#slide1-icon-${this.id}`, 0.5, { opacity: 0, scale: 0 , transformOrigin: '50% 50%'}, 'startScaleIconSlide01');
  }

  public animateTilastokeskusScaleBarsWithSomeDelay(timeline, values?, id?) {
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    timeline.staggerFrom(`.tilastokeskus-logo-top-${idValue}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 0.1, 'startAppearTilastokeskusBars');
    timeline.staggerFrom(`.tilastokeskus-logo-bottom-${idValue}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 0.1, 'startAppearTilastokeskusBars');
  }

  public animateBarsSlide2(timeline, values, data) {
    let legendLabels = _.drop(this.data[0], this.params['data']['rowLabelNumber'] || 0);
    _.map(legendLabels, (label, index) => {
      let tl = new TimelineMax();
      tl.fromTo(`.legend-${this.id}-cat-${index}`, 1, { opacity: 0 }, { opacity: 1 }, `animateBarsCat${index}`);
      tl.from(`.bars-${this.id}-subcat${index}`, 1, { attr: { height: '0' } }, `animateBarsCat${index}`);
      tl.set({}, {}, 4);
      timeline.add(tl);
    });
    return timeline;
  }

  public animateDanmarksStatistik(timeline, values?) {
    let crownId = `#Crown-${this.id}`;
    let danmarksId = `#Danmarks-${this.id}`;
    let statistikId = `#Statistik-${this.id}`;
    let textId = `#slide-03-text-${this.id}`;
    let tl = new TimelineMax();
    timeline.add(tl);
    tl.set({}, {}, 2);
    tl.fromTo(crownId, 1, { scale: 5.4 }, { scale: 1 })
    // tl.set({}, {}, 1);
    tl.fromTo(danmarksId, 1, { x: 600 }, { x: 8 }, '2.4')
    // tl.set({}, {}, 1);
    tl.fromTo(statistikId, 1, { x: 600 }, { x: 8 }, '2.6')
    tl.set({}, {}, 1.5);
    tl.fromTo(textId, 1, { opacity: 0 }, { opacity: 1 });
    return timeline;
  }

}




// WEBPACK FOOTER //
// ./src/app/animations/demo-dst-triptych-line-hor-steps/demo-dst-triptych-line-hor-steps.component.ts